export const SliderData = [
  {
    image:
      'https://i.pinimg.com/originals/56/9f/71/569f717f05c24cff0b325b3ed8004e85.jpg'
  },
  {
    image:
      'https://www.muycomputer.com/wp-content/uploads/2020/05/The-Last-of-Us-Part-II.jpg'
  },
  {
    image:
      'https://www.digitaltoo.com/wp-content/uploads/sites/3/2020/07/The-Last-of-US-2-01.jpg'
  },
  {
    image:
      'https://cdna.artstation.com/p/assets/images/images/028/266/238/large/matthew-trevelyan-johns-gf-05.jpg?1593975949'
  },
  {
    image:
      'https://www.ecestaticos.com/imagestatic/clipping/4af/205/4af205af3461e75da36ff4dc8f5b898e/the-last-of-us-2-el-mejor-juego-del-ano-parece-un-brutal-experimento-sobre-el-covid.jpg?mtime=1622465255'
  },
  {
    image:
      'https://i.pinimg.com/originals/ef/03/4b/ef034bbc35c150b7e9f4e9e69ce21944.jpg'
  },
  {
    image:
      'https://i.pinimg.com/originals/86/85/be/8685be8146fda80e149fb295a3a33b79.jpg'
  },
  {
    image:
      'https://cl.buscafs.com/www.levelup.com/public/uploads/images/625175/625175.jpg'
  },
  {
    image:
      'https://dibujando.net/files/fs/p/c/900x1000/2017/7/TLOU_299479.jpg'
  },
  {
    image:
      'https://magazine.artstation.com/wp-content/uploads/2020/06/eytan_header_c-1200x400.jpg'
  },
  {
    image:
      'https://tienda.notodoanimacion.es/wp-content/uploads/2021/06/home_the-last-of-us-2_naughty_dog.jpeg'
  },
  {
    image:
      'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/686a5070274631.5b9e7298447e1.png'
  },
  {
    image:
      'https://images.squarespace-cdn.com/content/v1/583f8fdacd0f688711edf9c0/1603757275002-12WAPBRCBBVVYTWB2L2I/kristian-llana-t2-118-bridge-point-3.jpg?format=2500w'
  },
  {
    image:
      'https://pbs.twimg.com/media/EcV3YIYUYAA5s1Y.jpg'
  },
  {
    image:
      'https://pbs.twimg.com/media/Eb2-lwsU0AA4ka4.jpg'
  },
  {
    image:
      'https://magazine.artstation.com/wp-content/uploads/2020/06/robby-johnson-floodedcity-arcade-rjedit_r.jpg'
  },
  {
    image:
      'https://www.iamag.co/wp-content/uploads/2020/06/The-Last-of-Us-Part-II-Concept-Art-3.jpg'
  },
  {
    image:
      'https://assets1.ignimgs.com/2019/11/22/hunting-in-the-woods-the-last-of-us-2-naughty-dog-1574426236509.jpg'
  },
  {
    image:
      'https://www.candb.com/site/candb/images/artwork/The-Last-of-Us-Left-Behind-Print_Naughty-Dog.jpg'
  },
  {
    image:
      'https://cdna.artstation.com/p/assets/images/images/030/152/668/4k/rado-markovic-hospital.jpg?1599756149'
  },
  {
    image:
      'https://cdnb.artstation.com/p/assets/images/images/028/083/409/4k/jx-saber-t2-143-safeco-field-color-logo.jpg?1595317124'
  },
  {
    image:
      'https://i.pinimg.com/originals/d8/78/00/d8780076dc7fb93279bb42986861a6ee.png'
  },
  {
    image:
      'https://pbs.twimg.com/media/EdKoOThWsAIyXbF.jpg'
  },
];
